import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsEs from '@angular/common/locales/es';

registerLocaleData(localeEsEs);
registerLocaleData(localeEsMx);

bootstrapApplication(AppComponent, appConfig).then(() => {
  window.dispatchEvent(new Event("AngularReady"));
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/ngsw-worker.js')
    .then(() => {
      return navigator.serviceWorker.register('/custom-sw.js');
    })
    .catch(err => console.error('Error al registrar SW', err));
}
